import React from 'react'
import css from './Footer.module.css'
import wave from '../assets/wave.png'
import v from '../assets/v-.png'

const Footer = () => {
  return (

<div className={css.footerbg}>
<img src={wave}/>

    <div className={css.footercontent}>
        <p>Vinoth kumar R</p>
<img src={v}/>
    </div>
</div>    
)
}

export default Footer